import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { CFG_CHIP_GRID_WIDE_LAST } from '../../lib/configuratorChip';
import { cn } from '../../lib/utils';

type Props = {
  children: ReactNode;
  className?: string;
};

/** Сетка плиток конфигуратора с layout-анимацией при смене col-span. */
export function ConfiguratorChipGrid({ children, className }: Props) {
  return (
    <motion.div layout className={cn(CFG_CHIP_GRID_WIDE_LAST, className)}>
      {children}
    </motion.div>
  );
}
